import { RICOS_VERSION } from './../../ricos-schema/next-schema/index.js';
import type { Helpers } from './../../ricos-types/index.js';

import type { ContentViewerProps } from '../types.js';

export const applyBIGenerics =
  (getContentId: () => string | undefined) =>
  ({ helpers = {}, ...rest }: Partial<ContentViewerProps>): Partial<ContentViewerProps> => ({
    ...rest,
    helpers: {
      ...helpers,
      onViewerLoaded: args =>
        helpers.onViewerLoaded?.({ ...args, version: RICOS_VERSION, contentId: getContentId() }),
      onViewerAction: (pluginId, actionName, value, contentId, partialNode) =>
        helpers.onViewerAction?.(
          pluginId,
          actionName,
          value,
          contentId || getContentId(),
          partialNode
        ),
    } as Helpers,
  });
